import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            赛事分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">选择你热爱的体育项目，深入探索精彩赛事</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="bg-background-50 border border-background-200 rounded-xl p-6 text-center hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="font-semibold text-foreground-950 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-400">{cat.matchCount} 场赛事</p>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}